import { useState } from "react";
import { Outlet } from "react-router-dom";
import { Header } from "./Header";
import { Sidebar } from "./Sidebar";
import { useOpsAuth } from "@/hooks/useOpsAuth";

export function AppShell() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const auth = useOpsAuth();

  return (
    <div className="app-shell">
      <Header
        onMenuClick={() => setSidebarOpen(true)}
        userEmail={auth.profile?.email}
        onSignOut={auth.logout}
      />
      <div className="app-body">
        <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
        <div
          className={`sidebar-overlay ${sidebarOpen ? "is-visible" : ""}`}
          onClick={() => setSidebarOpen(false)}
          aria-hidden="true"
        />
        <main className="app-main">
          <Outlet context={auth} />
        </main>
      </div>
    </div>
  );
}
